import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import { formatGraphqlErrors } from 'utils/helpers';
import { ContactMessagesDocument, MarkMessageReadDocument } from 'graphql/generated/graphql';

const useMarkMessageRead = () => {
  const [markMessageRead] = useMutation(MarkMessageReadDocument);
  const handleChange = useCallback(
    async (messageId: string, page: number) => {
      try {
        await markMessageRead({
          variables: { messageId },
          refetchQueries: [
            {
              query: ContactMessagesDocument,
              variables: { page, offset: 20 * (page - 1), limit: 20 },
            },
          ],
        });
      } catch (error) {
        throw formatGraphqlErrors(error);
      }
    },
    [markMessageRead],
  );
  return handleChange;
};

export default useMarkMessageRead;
